export default __webpack_public_path__ + "static/media/mcgill-logo.561da4ec.svg";